import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import {
  resetUpdateTimelineEvent,
  updateTimelineEvent,
} from "@academy-context/write/application/use-cases/admin/timeline-event-update/update-timeline-event";

const initialState: ProcessingState = { processing: "idle" };

export const updateTimelineEventReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateTimelineEvent.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updateTimelineEvent.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateTimelineEvent.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateTimelineEvent, () => {
    return initialState;
  });
});
